import modules_user from './user/index.js'
import modules_serviceClass from './serviceClass/index.js'
import modules_requestSource from './requestSource/index.js'
import modules_regularStates from './regularStates/index.js'
import modules_regularPaymentType from './regularPaymentType/index.js'
import modules_rateArticle from './rateArticle/index.js'
import modules_paymentType from './paymentType/index.js'
import modules_paymentOperation from './paymentOperation/index.js'
import modules_paymentMethod from './paymentMethod/index.js'
import modules_paymentDirection from './paymentDirection/index.js'
import modules_paymentCategory from './paymentCategory/index.js'
import modules_paymentAccount from './paymentAccount/index.js'
import modules_payed from './payed/index.js'
import modules_partner from './partner/index.js'
import modules_ownerLegalEntity from './ownerLegalEntity/index.js'
import modules_orderStatus from './orderStatus/index.js'
import modules_kindOfPay from './kindOfPay/index.js'
import modules_invoiceStatus from './invoiceStatus/index.js'
import modules_invoiceStates from './invoiceStates/index.js'
import modules_department from './department/index.js'
import modules_currencyUsed from './currencyUsed/index.js'
import modules_currency from './currency/index.js'
import modules_contragentType from './contragentType/index.js'
import modules_cash from './cash/index.js'
import modules_adSource from './adSource/index.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    modules:{
        adSource: modules_adSource,
        cash: modules_cash,
        contragentType: modules_contragentType,
        currency: modules_currency,
        currencyUsed: modules_currencyUsed,
        department: modules_department,
        invoiceStates: modules_invoiceStates,
        invoiceStatus: modules_invoiceStatus,
        kindOfPay: modules_kindOfPay,
        orderStatus: modules_orderStatus,
        ownerLegalEntity: modules_ownerLegalEntity,
        partner: modules_partner,
        payed: modules_payed,
        paymentAccount: modules_paymentAccount,
        paymentCategory: modules_paymentCategory,
        paymentDirection: modules_paymentDirection,
        paymentMethod: modules_paymentMethod,
        paymentOperation: modules_paymentOperation,
        paymentType: modules_paymentType,
        rateArticle: modules_rateArticle,
        regularPaymentType: modules_regularPaymentType,
        regularStates: modules_regularStates,
        requestSource: modules_requestSource,
        serviceClass: modules_serviceClass,
        user: modules_user,
    },
}